<template>
  <section class="page-body">
    <v-container>
      <v-dialog class="ma-0 pa-0" width="900px" v-model="showDialog" scrollable>
        <template v-if="showDialog">
          <Beneficiary
            @closeDialog="closeDialog"
            @getBenficiary="getBenficiary()"
            :showDialog="showDialog"
            :cust_id="$route.query.cust_id"
            :policy_number="recievedPolicy_number"
          />
        </template>
      </v-dialog>

      <v-dialog
        class="ma-0 pa-0"
        width="900px"
        v-model="showBusDialog"
        scrollable
      >
        <template v-if="showBusDialog">
          <BusBeneficiary
            @closeBusDialog="closeBusDialog"
            @getBenficiary="getBenficiary()"
            :cust_id="$route.query.cust_id"
            :showBusDialog="showBusDialog"
          />
        </template>
      </v-dialog>
      <v-card class="bg-color">
        <v-card-title>
          <span class="font-weight-normal">Customer Name</span>:
          {{ customer_name }}</v-card-title
        >
        <v-row>
          <v-col lg="6" sm="12">
            <v-menu :offset-x="true" open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  rounded
                  color="primary"
                  class="me-2 mt-5 v-custome-btn pa-5"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark left>mdi-account-plus </v-icon>
                  {{ $t("add_bene_label") }}
                </v-btn>
              </template>

              <v-list>
                <v-list-item link @click="onAddBen">
                  <v-list-item-title
                    ><v-icon class="mb-1 me-2"> mdi-account-tie</v-icon>
                    {{ $t("personal") }}</v-list-item-title
                  >
                </v-list-item>
                <v-list-item link @click="onAddBusBen">
                  <v-list-item-title
                    ><v-icon class="mb-1 me-2">mdi-briefcase-account</v-icon
                    >{{ $t("business") }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="filter"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
        </v-row>
        <v-data-table :items="userItems" :headers="headers" :search="filter">
          <template v-slot:item.bank="{ item }">
            <span>
              {{ item.location_name ? item.location_name : "" }}
            </span>
            <p
              v-if="item.payment_data && item.payment_data.value_code == 'B'"
              class="mb-0"
            >
              Account No: {{ item.bank_account_no }}
            </p>
            <p
              v-if="item.payment_data && item.payment_data.value_code == 'B'"
              class="mb-0"
            >
              Branch Code: {{ item.branch_code }}
            </p>
          </template>
          <template v-slot:item.full_name="{ item }">
            <span class="font-weight-bold">{{ item.full_name }}</span>
            <p class="mb-0">
              {{ item.relationship_data ? item.relationship_data.value : "" }}
            </p>
          </template>
          <template v-slot:item.country_data="{ item }">
            <p class="mb-0">
              {{ item.country_data ? item.country_data.name : "" }}
            </p>
          </template>
          <template v-slot:item.payment_data="{ item }">
            <p class="mb-0">
              {{ item.payment_data ? item.payment_data.value : "" }}
            </p>
          </template>
          <template v-slot:item.receiver_type_data="{ item }">
            <v-chip
              v-if="item.receiver_type_data"
              small
              outlined
              :color="
                item.receiver_type_data &&
                item.receiver_type_data.user_type == 'IND'
                  ? 'primary'
                  : 'Info'
              "
            >
              {{ item.receiver_type_data ? item.receiver_type_data.value : "" }}
            </v-chip>
          </template>
          <template v-slot:item.action="{ item }">
            <div class="d-flex">
              <!-- <v-btn
                :disabled="item.is_txn"
                class="mr-2 action-btn"
                :title="$t('update_bene_lable')"
                @click="editRemittee(item)"
                icon
              >
                <v-icon>mdi-account-edit-outline</v-icon>
              </v-btn> -->
              <v-btn
                class="mr-2 action-btn"
                :title="$t('delete_bene_label')"
                @click="openDialogCOnfirmation(item)"
                icon
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <!-- <v-btn
                @click="info(item, $event.target)"
                class="mr-2 action-btn"
                :title="$t('bene_start_txn')"
                icon
              >
                <v-icon class="mdi-rotate-315">mdi-send</v-icon>
              </v-btn> -->
            </div>
          </template>
        </v-data-table>
      </v-card>

      <!-- Delete confirmation popup dialog -->
      <v-dialog v-model="openDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom">
            {{ $t("delete_beneficary") }}</v-card-title
          >
          <!-- <v-divider></v-divider> -->
          <v-card-text class="h5 py-3">
            {{ $t("are_you sure want_to_delete_beneficary") }}
            <strong>{{ remitee_selected.first_name }} </strong>?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="text-capitalize"
              outlined
              @click="onDeleteDetil"
            >
              {{ $t("yes") }}<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              class="text-capitalize"
              outlined
              @click="openDialog = false"
              >{{ $t("no") }} <v-icon>mdi-close</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
// import remitteService from "@/services/RemitteService/remitteService.js";
import agentService from "@/services/agentService/AgentService.js";
import Beneficiary from "@/views/beneficiary/Beneficiary.vue";
import BusBeneficiary from "@/views/beneficiary/BenificiaryBus.vue";
export default {
  mixins: [alerts],
  name: "Beneficiary Summary",
  data() {
    return {
      isexceedBenelimit: false,
      filter: null,
      customer_name: "",
      headers: [
        {
          text: this.$t("name"),
          value: "full_name",
          align: "left",
        },
        {
          text: this.$t("country"),
          value: "country_data",
          align: "left",
        },
        {
          text: "User Type",
          value: "receiver_type_data",
          align: "left",
        },
        {
          text: this.$t("bank_details"),
          value: "bank",
          align: "left",
        },
        {
          text: this.$t("paymentType"),
          value: "payment_data",
          align: "left",
        },
        {
          text: this.$t("currency"),
          value: "currency_code",
          align: "left",
        },
        {
          text: this.$t("action"),
          value: "action",
          align: "center",
        },
      ],
      userItems: [],
      loader: false,
      fullPage: true,
      height: 100,
      width: 100,
      openDialog: false,
      remitee_selected: {},
      showDialog: false,
      showBusDialog: false,
      country_obj: [],
    };
  },
  components: { Beneficiary, BusBeneficiary },
  async mounted() {
    if (this.$route.query.name) {
      this.customer_name = this.$route.query.name;
    }
    await this.getBenficiary();
  },
  methods: {
    closeDialog(val) {
      console.log(val);
      this.showDialog = val;
    },
    closeBusDialog(val) {
      console.log(val);
      this.showBusDialog = val;
    },
    onAddBen() {
      this.showDialog = true;
      this.$store.state.showDialog = true;
      // this.$router.push("/beneficiary/true");
    },
    onAddBusBen() {
      this.showBusDialog = true;
      this.$store.state.showDialog = true;
      // this.$router.push("/beneficiary/true");
    },
    async getBenficiary() {
      try {
        const responseData = await agentService.getremitteeList(
          this.$route.query.cust_id
        );
        console.log("responseData.data", responseData.data);
        if (responseData.data.status_code === 200) {
          console.log("responseData.data", responseData.data);
          this.userItems = [...responseData.data.data.reverse()];
        } else {
          this.showAlertError(
            `Fetching Data Failed: ${responseData.data.message}`
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    openDialogCOnfirmation(remitee) {
      console.log("logss", remitee);
      this.remitee_selected = remitee;
      this.openDialog = true;
    },
    async onDeleteDetil() {
      try {
        this.openDialog = false;
        this.loader = true;
        const responseData = await agentService.deleteBene(
          this.remitee_selected.receiver_id
        );
        if (responseData && responseData.data.status_code === 200) {
          this.getBenficiary();
          this.loader = false;
          this.showAlertSuccess(this.$t("beneficiary_delete_success_msg"));
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    async info(item) {
      console.log("item: ", item);
      this.loader = true;
      try {
        const responseData = await this.$store.dispatch(
          "Remittee/getRemitteDetailByID",
          item.receiver_id
        );
        console.log("res start", responseData);
        if (responseData.data.status_code === 200) {
          this.loader = false;
          //to send selected bene data to the send money page
          this.$store.state.data = responseData.data.data[0];
          this.$router.push("/transaction");
        } else {
          this.loader = false;
          this.alertMsg = {
            status: true,
            text: "something went wrong.",
            color: "warning",
            type: "warning",
          };
        }
      } catch (err) {
        this.loader = false;
        console.log(err);
      }
    },
    editRemittee(item) {
      if (item.rec_type == "BUS")
        this.$router.push({
          path: "/beneficiary-bus",
          query: { Remittee_ID: item.receiver_id },
        });
      else
        this.$router.push({
          path: "/beneficiary",
          query: { Remittee_ID: item.receiver_id },
        });
    },
  },
};
</script>
<style lang="scss">
@import "@/global.scss";
.row {
  margin: 5px;
}
.action-btn {
  // background: $primary;
  border-radius: 4px;
  // color: $white !important;
  border: none !important;
}
.action-btn:hover {
  color: $primary !important;
}
.action-div {
  text-align: end;
}
::v-deep .table {
  td {
    vertical-align: middle !important;
  }
}

::v-deep th {
  color: $txt !important;
  font-size: 14px;
  font-weight: 600;
}

.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: auto !important;
  min-height: 2px !important;
}
.v-application--is-ltr .v-data-table__mobile-row__cell {
  text-align: left !important;
}
.text-col {
  color: rgb(130, 127, 127);
  font-size: 12px;
}
.center {
  justify-content: center;
  align-items: center;
}
.flag-style {
  font-size: 46px;
  border-radius: 50%;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.flag-size {
  font-size: 33px;
  border-radius: 50%;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.width-100 {
  width: 78vw;
}
.font {
  font-size: 9px;
}
.font-name {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 700;
}
</style>
